import { render, staticRenderFns } from "./MyMarquee.vue?vue&type=template&id=69f0383c&scoped=true&"
import script from "./MyMarquee.vue?vue&type=script&lang=js&"
export * from "./MyMarquee.vue?vue&type=script&lang=js&"
import style0 from "./MyMarquee.vue?vue&type=style&index=0&id=69f0383c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f0383c",
  null
  
)

export default component.exports